var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"banner"},[(_vm.workplaceTopAd)?_c('img',{staticClass:"banner-img",attrs:{"src":_vm.workplaceTopAd}}):_vm._e()]),(
			_vm.$store.state.user.userInfo &&
			(_vm.$store.state.user.userInfo.type == _vm.$api.account.types.PLATFORM_ADMIN.value ||
				_vm.$store.state.user.userInfo.type == _vm.$api.account.types.OTHER.value)
		)?_c('platform-admin-stats'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }